import { useRef, useState } from "react";
import { Camera } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { initials } from "@/lib/format";
import { Spinner } from "@/components/common/States";

export const UserAvatar = ({ path, name, size = "h-10 w-10", textSize = "text-sm" }) => {
  const [failed, setFailed] = useState(false);
  if (path && !failed)
    return <img src={fileUrl(path)} alt={name} onError={() => setFailed(true)} className={`${size} shrink-0 rounded-full object-cover`} />;
  return (
    <div className={`${size} ${textSize} flex shrink-0 items-center justify-center rounded-full bg-primary/15 font-semibold text-primary`}>
      {initials(name) || "?"}
    </div>
  );
};

export const PhotoUpload = ({ value, onChange, name, testId = "photo-upload" }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const form = new FormData();
    form.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/files/upload", form);
      onChange(data.path);
      toast.success("Foto enviada");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-4">
      <UserAvatar path={value} name={name} size="h-16 w-16" textSize="text-lg" />
      <button
        type="button"
        onClick={() => ref.current?.click()}
        className="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition-colors hover:bg-muted"
        data-testid={`${testId}-btn`}
      >
        {busy ? <Spinner /> : <Camera className="h-4 w-4" />} {value ? "Trocar foto" : "Adicionar foto"}
      </button>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" hidden onChange={upload} data-testid={`${testId}-input`} />
    </div>
  );
};
